/**
 * Display helpers for the Finished Product — Orange report.
 *
 * Local to this report rather than in `shared/` — the §8.7 seam rule is that a
 * new report edits only `index.ts` and `report.css` among the shared files, and
 * week formatting has exactly one consumer today. Promote these to `shared/`
 * when a second weekly report exists, not before.
 */

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

/** "2026-07-27" -> "Jul 27, 2026". A value that is not a date passes through. */
export function weekLabel(week: string): string {
  const [year, month, day] = week.split('-')
  const name = MONTH_NAMES[Number(month) - 1]
  if (name === undefined || year === undefined || day === undefined) return week
  return `${name} ${Number(day).toString()}, ${year}`
}

/** "2026-07-27" -> "Jul 27" — for dense axes where the year is on its own row. */
export function weekShort(week: string): string {
  const [, month, day] = week.split('-')
  const name = MONTH_NAMES[Number(month) - 1]
  if (name === undefined || day === undefined) return week
  return `${name} ${Number(day).toString()}`
}

/** A spec value at its panel's precision; null (not measured) renders as a dash. */
export function fmtSpec(value: number | null, decimals: number): string {
  return value === null ? '—' : value.toFixed(decimals)
}

/** Date and time — samples within one week need the day and often the hour. */
export function formatDateTime(value: string | null): string {
  if (value === null) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
